import React from 'react';
import styles from './SubDiscipline.module.css';
import Link from 'next/link';

type Props = { articles: { title: string; link: string }[]; title: string };

const SubDiscipline = ({ articles, title }: Props) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.sub_discipline}>{title}</p>
      <div className={styles.articles_list}>
        {articles.map((e) => (
          <Link href={e.link} key={e.title}>
            <a className={styles.link}>{e.title}</a>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SubDiscipline;
